<button
  *ngIf="
    resource && permissions.hasPermission(permission.Create, activity) | async
  "
  class="floatFab"
  mat-fab
  matTooltip="Add Users"
  i18n-matTooltip
  color="primary"
  (click)="addUsers()"
>
  <mat-icon>add</mat-icon>
</button>
<div
  fxFlexFill
  fxLayout="column"
  fxLayoutAlign="center center"
  *ngIf="resource"
>
  <mat-card appearance="outlined">
    <mat-card-header>
      <button
        mat-icon-button
        class="close-button"
        matTooltip="Close"
        i18n-matTooltip
        [routerLink]="['..']"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-card-subtitle>{{
        mfa.getTypeName(resource!.type)
      }}</mat-card-subtitle>
      <mat-card-title>
        <span *ngIf="!editMode">{{ resource!.name }}</span>
        <mat-form-field *ngIf="editMode">
          <input
            matInput
            type="text"
            i18n-placeholder
            placeholder="Name"
            [(ngModel)]="resource.name"
          />
        </mat-form-field>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <table>
        <tr>
          <td i18n>Resource ID:</td>
          <td>{{ resource!.id }}</td>
          <td>
            <button
              mat-button
              (cdkCopyToClipboardCopied)="
                snackBar.openFromTemplate(snack, { duration: 2000 })
              "
              [cdkCopyToClipboard]="resource!.id"
            >
              Copy
            </button>
          </td>
        </tr>
        <tr>
          <td i18n>API Server:</td>
          <td *ngIf="!editMode">{{ resource!.apiServer }}</td>
          <td *ngIf="editMode">
            <mat-form-field>
              <input
                matInput
                type="text"
                matTooltip="Comma-separated list of SafeMFA servers"
                i18n-matTooltip
                i18n-placeholder
                placeholder="API Servers"
                [(ngModel)]="resource.apiServer"
              />
            </mat-form-field>
          </td>
          <td>
            <button
              mat-button
              (cdkCopyToClipboardCopied)="
                snackBar.openFromTemplate(snack, { duration: 2000 })
              "
              [cdkCopyToClipboard]="resource!.apiServer"
            >
              Copy
            </button>
          </td>
        </tr>
        <tr>
          <td i18n>Password:</td>
          <td class="non-hover-blur">{{ resource!.password }}</td>
          <td>
            <button
              mat-button
              (cdkCopyToClipboardCopied)="
                snackBar.openFromTemplate(snack, { duration: 2000 })
              "
              [cdkCopyToClipboard]="resource!.password"
            >
              Copy
            </button>
          </td>
        </tr>

        <tr
          *ngIf="
            editMode && resource.apiServer && resource.apiServer.includes(',')
          "
        >
          <td colspan="3">
            <mat-form-field>
              <input
                matInput
                type="number"
                matTooltip="Timeout to try each server, in seconds."
                i18n-matTooltip
                i18n-placeholder
                placeholder="Server Timeout"
                [(ngModel)]="resource.serverTimeout"
              />
            </mat-form-field>
          </td>
        </tr>
        <ng-container *ngIf="editMode">
          <tr>
            <td colspan="3">
              <mat-checkbox
                matTooltip="Check this to allow logging in with a Windows Live ID account."
                i18n-matTooltip
                i18n
                [(ngModel)]="resource.allowMicrosoftAccountLogin"
                >Allow Microsoft Account Login
              </mat-checkbox>
            </td>
            <td></td>
          </tr>

          <tr>
            <td colspan="3">
              <mat-checkbox
                matTooltip="Uncheck to disable SafeMFA on this resource. USE WITH CAUTION."
                i18n-matTooltip
                i18n
                [(ngModel)]="resource.safeMFAEnabled"
                >SafeMFA Enabled
              </mat-checkbox>
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="3">
              <mat-checkbox
                matTooltip="Only use with non-cloud servers/workstations that might be periodically offline."
                i18n-matTooltip
                i18n
                [(ngModel)]="resource.enableLoginCache"
                >Local Cache Enabled
              </mat-checkbox>
            </td>
            <td></td>
          </tr>
        </ng-container>

        <ng-template #snack>
          <span i18n>Copied!</span>
        </ng-template>
      </table>
    </mat-card-content>
    <mat-divider [inset]="true"></mat-divider>
    <mat-card-actions>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <button mat-button [routerLink]="['registered']" i18n>
          Registered Users
        </button>
        <button mat-button [routerLink]="['pending']" i18n>
          Pending Registrations
        </button>
        <button
          mat-icon-button
          style="margin-inline-start: auto"
          matTooltip="Download SafeMFA Client Application"
          i18n-matTooltip
          color="primary"
          download
          (click)="downloadProvider()"
        >
          <mat-icon *ngIf="!downloading">cloud_download</mat-icon>
          <mat-icon
            matTooltip="Downloading Client..."
            i18n-matTooltip
            class="rotating"
            *ngIf="downloading"
            >settings_backup_restore</mat-icon
          >
        </button>
        <button mat-icon-button color="accent" (click)="edit()">
          <mat-icon *ngIf="!editMode" matTooltip="Edit Settings" i18n-matTooltip
            >edit</mat-icon
          >
          <mat-icon
            matTooltip="Save Settings"
            i18n-matTooltip
            *ngIf="editMode"
            [svgIcon]="saving ? 'timer-sand' : 'download'"
          ></mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="delete()">
          <mat-icon matTooltip="Delete this protected resource." i18n-matTooltip
            >delete</mat-icon
          >
        </button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>
